export default __webpack_public_path__ + "static/media/3031 knife block B side.a7ca80e5.png";